var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "my_dia",
          attrs: { visible: _vm.open },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c("div", { staticClass: "dia_header" }, [
            _c(
              "p",
              {
                class: { on: _vm.active === "delegate" },
                on: {
                  click: function ($event) {
                    return _vm.tabCliack("delegate")
                  },
                },
              },
              [_vm._v("Stake")]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                class: { on: _vm.active === "undelegate" },
                on: {
                  click: function ($event) {
                    return _vm.tabCliack("undelegate")
                  },
                },
              },
              [_vm._v("Unstake")]
            ),
          ]),
          _vm._v(" "),
          _vm.active === "delegate"
            ? _c("div", { staticClass: "stakeDes" }, [
                _c("div", { staticClass: "img" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/image/stake/icon2.png"),
                      alt: "",
                      width: "100%",
                    },
                  }),
                ]),
                _vm._v(
                  "\n      When you unstake, the staked UNIT will be transferred to your account after 21 days, and the rewards will arrive\n      shortly thereafter.\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "stakeForm",
              staticClass: "stake-form",
              attrs: {
                model: _vm.stakeForm,
                "label-width": _vm.isMobile ? "0" : "150px",
                rules: _vm.rules,
              },
            },
            [
              _c("el-form-item", { attrs: { label: "Validator：" } }, [
                _vm.userInfo.moniker
                  ? _c("div", { staticClass: "userinfo" }, [
                      _c("div", { staticClass: "img" }, [
                        _vm.userInfo.pictures
                          ? _c("img", {
                              attrs: { src: _vm.userInfo.pictures, alt: "" },
                            })
                          : _c("img", {
                              attrs: {
                                src: require("@/assets/image/stake/icon.png"),
                                alt: "",
                              },
                            }),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.userInfo.moniker)),
                      ]),
                      _vm._v(" "),
                      _vm.userInfo.website
                        ? _c(
                            "span",
                            {
                              staticClass: "web",
                              on: {
                                click: function ($event) {
                                  return _vm.handleOpen(_vm.userInfo.website)
                                },
                              },
                            },
                            [_vm._v("Website")]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.stakeForm.operator_address) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "My Staked：" } },
                [
                  _c("big-number", {
                    staticClass: "num",
                    attrs: { number: _vm.stakeForm.staked },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "td-word-sm" }, [_vm._v("UNIT")]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.active === "delegate"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Wallet Blance：" } },
                    [
                      _c("big-number", {
                        staticClass: "num",
                        attrs: { number: _vm.stakeForm.blance },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "td-word-sm" }, [
                        _vm._v("UNIT"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.amountLabel + "：", prop: "amount" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "amount-input",
                      style: { width: _vm.isMobile ? "100%" : "3.5rem" },
                      model: {
                        value: _vm.stakeForm.amount,
                        callback: function ($$v) {
                          _vm.$set(_vm.stakeForm, "amount", $$v)
                        },
                        expression: "stakeForm.amount",
                      },
                    },
                    [_c("template", { slot: "suffix" }, [_vm._v("UNIT")])],
                    2
                  ),
                  _vm._v(" "),
                  _vm.active === "undelegate" && _vm.stakeForm.staked > 0
                    ? _c(
                        "span",
                        { staticClass: "maxbtn", on: { click: _vm.handleMax } },
                        [_vm._v("MAX")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn_box" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { disabled: _vm.btnFlag },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("Submit")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.active === "delegate" && _vm.stakeForm.staked > 0
            ? _c("div", { staticClass: "tips" }, [
                _c("p", [_vm._v("Tips:")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "You have already staked the Validator. If you continue to stake, the rewards will be recalculated and the\n        rewards you have already earned will be sent to your account."
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.active === "undelegate" && _vm.stakeForm.staked > 0
            ? _c("div", { staticClass: "tips" }, [
                _c("p", [_vm._v("Tips:")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "After unstaking, the staked UNIT will be sent to your account after 21 days, and the rewards will arrive\n        shortly thereafter."
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("handle", { ref: "handleCom", on: { success: _vm.handleSuccess } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }